import { createSupportingModule, DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

enum SECTION_ENUM {
  OPINION = 'オピニオン',
  SHASETSU = '社説',
  KIKO = '寄稿'
}
const { OPINION, SHASETSU, KIKO } = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { terms: { key: 'SectionType', value: [OPINION, SHASETSU, KIKO] } }
    ]
  },
  ...DEFAULT_SORT
};

const OPINION_QUERY = createSupportingModule([OPINION]);
const SHASETSU_QUERY = createSupportingModule([SHASETSU]);
const KIKO_QUERY = createSupportingModule([KIKO]);

export { SECTION_ENUM, baseQuery as MAIN, OPINION_QUERY, SHASETSU_QUERY, KIKO_QUERY };
